$(document).ready(function () {

    $(document).on('click', 'a.disabled', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    });

    $(document).on("click", ".confirmLink, .confirm-link", function (e) {

        if (e.isPropagationStopped() || e.isImmediatePropagationStopped()) {
            return false;
        }

        let link = $(this);

        confirmEvent(e, link, function () {

            let url = link.data("href");
            let isBlank = isDefined(link.attr('target')) && link.attr('target') === "_blank";

            if (isBlank) {
                window.open(url, '_blank').focus();
            } else {
                $.nette.ajax({
                    url: url,
                    type: "GET",
                    off: {
                        snippets: true
                    }
                });
            }

        });

    });

    $(document).on("click", ".confirmFormBtn, .confirm-form-btn", function (e) {

        if (e.isPropagationStopped() || e.isImmediatePropagationStopped()) {
            return false;
        }

        let btn = $(this);
        confirmEvent(e, btn, function (formData) {

            $.nette.ajax({
                url: btn.closest('form').attr('action'),
                data: formData,
                type: "POST",
                off: {
                    snippets: true
                }
            });

        });

    });

    $(document).on('click', ".custom-ajax", function (e) {

        if (e.isPropagationStopped() || e.isImmediatePropagationStopped()) {
            return false;
        }

        e.preventDefault();

        let btn = $(this);
        let form = $(this).closest('form');
        btn.prop('disabled', true);

        let formData = new FormData(form.get(0));

        addFileUploaderData(form, formData);

        form.find('.text-editor').each(function () {
            let textEditor = $(this);
            formData.append($(this).attr('name'), $(this).data('instance').getData());
        });

        $.nette.ajax({
            url: form.attr('action'),
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            off: {
                snippets: true
            },
            success: function () {
                btn.prop('disabled', false);
            },
            error: function (msg) {
                btn.prop('disabled', false);
                toastr.warning(msg);
            }
        });

    });

    $(document).on('click', "input[type='checkbox'][readonly='readonly'], input[type='checkbox']:disabled", function (e) {
        e.preventDefault();
        return false;
    });

});




